import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatINR } from "@/lib/api";
import { PageHeader, Spinner, EmptyState, Card, Table } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { Wallet, TrendingUp, Clock } from "lucide-react";

export default function Finance() {
  const [payments, setPayments] = useState(null);
  const [stats, setStats] = useState({});
  useEffect(() => {
    api.get("/payments").then((r) => setPayments(r.data)).catch(() => setPayments([]));
    api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  if (!payments) return <Spinner />;

  const paid = payments.filter((p) => p.status === "paid");

  return (
    <div className="animate-fadeUp">
      <PageHeader title="Finance" subtitle="Payments, collections and reconciliation" />

      <div className="mb-6 grid gap-4 sm:grid-cols-3">
        <Card>
          <div className="mb-2 flex items-center gap-2"><TrendingUp className="h-5 w-5 text-emerald-400" /><p className="font-mono text-xs uppercase text-muted-foreground">Collected</p></div>
          <p className="font-display text-3xl font-bold text-emerald-400">{formatINR(stats.revenue)}</p>
        </Card>
        <Card>
          <div className="mb-2 flex items-center gap-2"><Clock className="h-5 w-5 text-amber-400" /><p className="font-mono text-xs uppercase text-muted-foreground">Outstanding</p></div>
          <p className="font-display text-3xl font-bold text-amber-400">{formatINR(stats.outstanding)}</p>
        </Card>
        <Card>
          <div className="mb-2 flex items-center gap-2"><Wallet className="h-5 w-5 text-primary" /><p className="font-mono text-xs uppercase text-muted-foreground">Successful payments</p></div>
          <p className="font-display text-3xl font-bold">{paid.length}</p>
        </Card>
      </div>

      {payments.length === 0 ? (
        <EmptyState icon={Wallet} title="No payments yet" text="Payment records appear here once bookings are paid." />
      ) : (
        <Table head={["Order ID", "Booking", "Institution", "Amount", "Mode", "Status", "Date"]}>
          {payments.map((p) => (
            <tr key={p.id} data-testid={`payment-row-${p.id}`} className="border-b border-border/60 last:border-0 hover:bg-background/40">
              <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{p.order_id}</td>
              <td className="px-4 py-3"><Link to={`/app/bookings/${p.booking_id}`} className="font-mono text-xs text-primary hover:underline">{p.booking_reference}</Link></td>
              <td className="px-4 py-3 text-muted-foreground">{p.institution_name}</td>
              <td className="px-4 py-3 font-mono">{formatINR(p.amount)}</td>
              <td className="px-4 py-3 text-xs text-muted-foreground">{p.simulated ? "Test" : "Razorpay"}</td>
              <td className="px-4 py-3"><StatusBadge status={p.status} /></td>
              <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{(p.paid_at || p.created_at || "").slice(0, 10)}</td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
